import { render } from "./dl-button.vue?vue&type=template&id=b4b638bc"
import script from "./dl-button.vue?vue&type=script&lang=js"
export * from "./dl-button.vue?vue&type=script&lang=js"

import "./dl-button.vue?vue&type=style&index=0&id=b4b638bc&lang=scss"

import exportComponent from "/var/www/doctolib-hos-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__